import { useQuery } from '@tanstack/react-query'
import { fetchFactionsByParty, factionKeys } from '@/services/factions'

export function useFactionsByParty(partyId: string | undefined) {
  const factionsQuery = useQuery({
    queryKey: factionKeys.byParty(partyId!),
    queryFn: () => fetchFactionsByParty(partyId!),
    enabled: !!partyId,
  })

  return {
    factions: factionsQuery.data,
    isLoading: factionsQuery.isLoading,
    error: factionsQuery.error,
  }
}
